module.exports = __webpack_public_path__ + "img/adventurealtitude.7f74d24a.jpg";